import type { LocalePack } from './types.js';

/** Swedish (Svenska) */
export const sv: LocalePack = {
  headerTitle: 'Fotoredigerare',
  headerSubtitle: 'Redigera din bild med lätthet',
  applyButton: 'Tillämpa',
  cancelButton: 'Stäng',
  undo: 'Ångra',
  redo: 'Gör om',
  fullscreen: 'Helskärm',
  fit: 'Anpassa',
  zoomTooltip: 'Zoom · +/− · 0 anpassa · 1 100 %',

  emptyStateTitle: 'Släpp en bild eller klicka för att ladda upp',
  emptyStateSubtitle: 'Stöds: PNG, JPEG, HEIC',

  calloutLabelText: 'Etikett',

  tool: {
    select: 'Markera',
    crop: 'Beskär',
    draw: 'Rita',
    eraser: 'Suddgummi',
    text: 'Text',
    shapes: 'Former',
    callout: 'Notis',
    filters: 'Filter',
    adjust: 'Justera',
    move: 'Flytta',
    pen: 'Penna',
    zoom: 'Zoom',
    zoomIn: 'Zooma in',
    zoomOut: 'Zooma ut',
    rotateLeft: 'Rotera vänster',
    rotateRight: 'Rotera höger',
    flipH: 'Vänd H',
    flipV: 'Vänd V',
    reset: 'Återställ',
  },

  shape: {
    circle: 'Cirkel',
    ellipse: 'Ellips',
    square: 'Kvadrat',
    rectangle: 'Rektangel',
    arrow: 'Pil',
    polyline: 'Linjebana',
  },

  filter: {
    none: 'Original',
    grayscale: 'S/V',
    sepia: 'Sepia',
    vintage: 'Vintage',
    cool: 'Kall',
    warm: 'Varm',
    invert: 'Invertera',
  },

  props: {
    title: {
      draw: 'Rita',
      eraser: 'Suddgummi',
      text: 'Text',
      crop: 'Beskär',
      shapes: 'Former',
      callout: 'Notis',
      filters: 'Filter',
      adjust: 'Justera',
      move: 'Flytta',
    },
    aspectRatio: 'Bildförhållande',
    applyCrop: 'Tillämpa beskärning',
    cancel: 'Avbryt',
    shape: 'Form',
    preset: 'Förinställning',
    resetEffects: 'Återställ effekter',
    resetAdjustments: 'Återställ justeringar',
    deleteSelected: 'Ta bort markerat',
    colors: 'Färger',
    recent: 'Senaste',
    customColor: 'Egen färg',
    brushSize: 'Penselstorlek',
    strokeWidth: 'Linjebredd',
    opacity: 'Opacitet',
    eraserSize: 'Suddgummistorlek',
    fontSize: 'Textstorlek',
    brightness: 'Ljusstyrka',
    contrast: 'Kontrast',
    saturation: 'Mättnad',
    blur: 'Oskärpa',
    quickActions: 'Snabbåtgärder',
    hintMove:
      'Dra för att panorera · nyp eller scrolla för att zooma · välj ett verktyg för att börja.',
    hintEraser: 'Tryck eller dra över en anteckning för att ta bort den.',
  },
};
